import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TenantService } from 'src/app/services/tenant.service';

@Component({
    selector: 'block-email-confirm-modal',
    templateUrl: './block-email-confirm-modal.component.html',
    styleUrls: ['./block-email-confirm-modal.component.css']
})
export class BlockEmailConfirmModalComponent {

    tenantDetails$ = this.tenantService.getTenantDetails();

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private tenantService: TenantService,
        private dialogRef: MatDialogRef<BlockEmailConfirmModalComponent>
    ) { }

    closeModal() {
        this.dialogRef.close();
    }
}